import axios from "axios";
import secureLocalStorage from "react-secure-storage";

const signUp = (username, email, password, role = "Assistant") => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${process.env.REACT_APP_NODE_BASE_URL}/user/signUp`, {
        username: username,
        email: email,
        password: password,
        role,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => reject(err));
  });
};

const login = (email, password) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${process.env.REACT_APP_NODE_BASE_URL}/user/login`, {
        email: email,
        password: password,
      })
      .then((res) => {
        console.log("Login Response Data:", res.data);
        secureLocalStorage.setItem("loginCredentials", res.data);

        const storedData = secureLocalStorage.getItem("loginCredentials");
        console.log("Stored Login Credentials:", storedData); // Debugging
        resolve(res.data);
      })
      .catch((err) => {
        console.log(err);
        reject(err.response.data.message);
      });
  });
};

const changePassword = (password, newpassword) => {
  const loginData = secureLocalStorage.getItem("loginCredentials");
  return new Promise((resolve, reject) => {
    axios
      .post(`${process.env.REACT_APP_NODE_BASE_URL}/user/changePassword`, {
        email: loginData.user.email,
        oldPassword: password,
        newPassword: newpassword,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        console.log(err);
        reject(err.response.data.message);
      });
  });
};

const getAllUsers = (token) => {
  console.log("Token:", token);

  return axios.get(`${process.env.REACT_APP_NODE_BASE_URL}/user/all-users`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export { signUp, login, changePassword, getAllUsers };
